import { render, staticRenderFns } from "./searchSupplies.vue?vue&type=template&id=2326789f&"
import script from "./searchSupplies.vue?vue&type=script&lang=js&"
export * from "./searchSupplies.vue?vue&type=script&lang=js&"
import style0 from "./searchSupplies.vue?vue&type=style&index=0&id=2326789f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports